<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-body>
        <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
          <b-row>
            <b-col>
              <b-form-group label="Name" label-for="name">
                <b-form-input id="name"
                              type="text"
                              :state="validateState('name')"
                              aria-describedby="liveFeedbackname"
                              v-model.lazy.trim="$v.form.name.$model"
                              placeholder="Name"
                              autofocus>
                </b-form-input>
                <b-form-invalid-feedback id="liveFeedbackname">
                  This is a required field and only contain characters.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="House No" label-for="houseno">
                <b-form-input id="houseno"
                              type="text"
                              readonly
                              :state="validateState('houseno')"
                              aria-describedby="liveFeedbackhouseno"
                              v-model.lazy.trim="$v.form.houseno.$model"
                              placeholder="House No" />
                <b-form-invalid-feedback id="liveFeedbackhouseno">
                  This is a required field.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Meter No" label-for="meterno">
                <b-form-input id="meterno"
                              type="text"
                              v-model.lazy.trim="form.meterno"
                              placeholder="Meter No" />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Meter Type" label-for="metertype">
                <b-form-input id="metertype"
                              type="text"
                              v-model.lazy.trim="form.metertype"
                              placeholder="Meter Type" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
             <b-form-group label="Electric Line" label-for="line">
               <v-select ref="line" id="line" name="line" :class="{ danger: $v.form.line.$error }" @search:blur="$v.form.line.$touch()" :state="validateState('line')" :options="lineList"  aria-describedby="liveFeedbackline" v-model="$v.form.line.$model" :reduce="line => line.id" label="lineName"></v-select>
               <span v-show="$v.form.line.$error" class="danger-span">
                 This is required field
             </span>
              <b-form-invalid-feedback id="liveFeedbackline">
                 This is a required field.
               </b-form-invalid-feedback>
             </b-form-group>
             </b-col>
            <b-col>
             <b-form-group label="Group" label-for="group">
               <v-select ref="group" id="group" name="group" :class="{ danger: $v.form.group.$error }" @search:blur="$v.form.group.$touch()" :state="validateState('group')" :options="groupList"  aria-describedby="liveFeedbackgroup" v-model="$v.form.group.$model" :reduce="group => group.id" label="name"></v-select>
               <span v-show="$v.form.group.$error" class="danger-span">
                 This is required field
             </span>
              <b-form-invalid-feedback id="liveFeedbackgroup">
                 This is a required field.
               </b-form-invalid-feedback>
             </b-form-group>
             </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table hover small :items="this.form.chargeTypes" :fields="fields" id="dataTable" ref="dataTable" responsive="sm">
                <template v-slot:cell(amount)="row">
                  <b-form-group label="" label-for="amount">
                    <b-form-input :name="`amount-${row.index}`"
                                  :id="`amount-${row.index}`"
                                  type="text"
                                  v-model="$v.form.chargeTypes.$each[row.index].amount.$model"
                                  :state="validateState('chargeTypes')"
                                  :aria-describedby="`liveFeedbackamount-${row.index}`"
                                  @blur="$v.form.chargeTypes.$touch()"
                                  placeholder="Amount" />
                                  <b-form-invalid-feedback :id="`liveFeedbackamount-${row.index}`">
                                    This is a required field and can only contain numbers.
                                  </b-form-invalid-feedback>
                  </b-form-group>
                </template>
                <template v-slot:cell(enabled)="row">
                  <b-form-checkbox  v-model="row.item.enabled" value="1" unchecked-value="0" switch>

                  </b-form-checkbox>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button type="submit" variant="primary" :disabled="$v.form.$invalid">
                Submit
              </b-button>
              <b-button class="ml-1" type="reset" @click="onCancel">Cancel</b-button>
              <br />
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>

  import Vue from 'vue'
  import VueLodash from 'vue-lodash'
  import map from 'lodash/map'
  import { mapState, mapActions } from 'vuex'
  import { required,decimal,helpers } from 'vuelidate/lib/validators'
  const alpha_space = helpers.regex('alpha_space', /^[a-zA-Z\s]*$/)
  const alpha_numeric = helpers.regex('alpha_space', /^[a-zA-Z0-9\s]*$/)
  const formShape = {
    name: null,
    meterno: null,
    houseno: null,
    metertype: null,
    line: null,
    group: null,
    chargeTypes: null
  }

  export default {
    name: 'ProfileEdit',
    props: {
      profile: Object
    },
    data() {
      return {
        form: Object.assign({}, formShape),
        submitted: false,
        fields: [   {key:'name', label:'Bhaint Type'},{key:'amount', label:'Amount'},
                    {key:'enabled', label:'Enabled?',formatter: (value, key, item) => {return value ? "1" : "0"}}
                ],
      }
    },
    computed: {
      isValid() {
        this.$v.$touch()
        return !this.$v.form.$anyError
      },
      isDirty() {
        return this.$v.form.$anyDirty
      },
      lineList() {
        return map(this.$store.state.electrical.electricLines, (line) => {
        return {
          lineName: line.lineName,
          id: line.id
        }
        })
      },
      groupList() {
        return map(this.$store.state.electrical.satsangiGroups, (group) => {
        return {
          name: group.name,
          id: group.id
        }
        })
      },
    },
    validations: {
      form: {
        name: {
          required,
          alpha_space
        },
        houseno: {
          required
        },
        line:{
          required
        },
        group:{
          required
        },
        chargeTypes:{
          $each: {
            amount: {
              required,
              decimal
            }
          }
      }

      }
    },
    methods: {
      validateState(name) {
        const { $dirty, $error } = this.$v.form[name]
        return $dirty ? !$error : null
      },
      onSubmit() {
        if (this.validate()) {
          this.$nextTick(() => {
            this.submitted = true
            let params = {
              name: this.$v.form.name.$model,
              meterno: this.form.meterno,
              houseno: this.$v.form.houseno.$model,
              electricline: this.$v.form.line.$model.id,
              groupid: this.$v.form.group.$model.id,
              metertype: this.form.metertype,
              id: this.profile.id,
              chargeTypes: this.form.chargeTypes
            }

            this.$store
              .dispatch('electrical/updateProfile', params)
              .then(response => {
                if (response.data.success == false) {
                  this.showErrorMsg({
                    message: response.data.error
                  })
                } else {
                  this.showSuccessMsg({
                    message: 'Record updated successfully.'
                  });
                  this.$emit('success')
                }

              })
              .catch(error => {
                if (error.response.status == 400) {
                  this.showErrorMsg({
                    message: error.response.data.message
                  })
                } else if (error.response.status == 422) {
                  this.showErrorMsg({
                    message: error.response.data.message
                  })
                } else {
                  this.showErrorMsg({ message: 'Something went wrong. Please contact administrator.' })
                }
              })
          })
        }
      },
      onCancel() {
        this.$emit('cancel')
      },
      onReset() {
        this.form = formShape
        this.$nextTick(() => {
          this.$v.$reset()
        })
      },
      validate() {
        this.$v.$touch()
        return !this.$v.form.$anyError
      }
    },
    beforeMount() {
    },
    created() {
      this.form.name = this.profile.name;
      this.form.meterno = this.profile.meterno;
      this.form.houseno = this.profile.houseno;
      this.form.metertype = this.profile.metertype;
      this.form.line = this.profile.electricline;
      this.form.group = this.profile.groupid;
      this.form.chargeTypes = this.profile.chargeTypes;
    }
  }

</script>

<style media="screen">
  .danger,
  .danger .dropdown-toggle,
  .danger .selected-tag {
    color: #f86c6b;
    border-color: #f86c6b;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23f86c6b' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23f86c6b' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
    background-repeat: no-repeat;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    background-position: right calc(0.375em + 0.95rem) center;
  }
  .danger-span{
    width:100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #f86c6b;

  }

  .borderCard{
    border: 1px solid #e3e8ec;
  }
</style>
